import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Comissao } from 'src/app/models/comissao';

@Component({
  selector: 'app-comissoes-modal',
  templateUrl: './comissoes-modal.component.html',
  styleUrls: ['./comissoes-modal.component.scss']
})
export class ComissoesModalComponent implements OnInit {

  valorTotal: number;
  comissao: Comissao;
  valorComissao: string;
  origemGI: number;
  valorCalculadoKitPronto: number;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<ComissoesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.valorTotal = data.valorTotal;
    this.comissao = data.comissao;
    this.valorComissao = data.valorComissao;
    this.origemGI = data.origemGI;
  }

  ngOnInit() {
    if(this.origemGI === 1) {
      this.valorCalculadoKitPronto = (this.valorTotal * this.comissao.percKitPronto) / 100;
    } else {
      this.comissao.itens.forEach(p => {
        p.valorCalculado = (this.valorTotal * p.valor) / 100;
      });
    }
  }

  fechar() {
    this.dialogRef.close();
  }

}
